Vendd.Scripts.load(function () {
    var $form = $('.x-article-review-form'),
        form, formData;

    if ($form.length < 1)
        return;

    formData = {
        reviewArticleId: parseInt($('input[name="reviewArticleId"]', $form).val()),
        reviewTitle: '',
        reviewDescription: '',
        reviewRating: ''
    };

    form = $form.get(0);

    var $submitButton = $('.js-submit-button', $form);

    //init validation options
    var validationOptions = {
        reviewTitle: {
            required: 'reviewTitle-required'
        },
        reviewDescription: {
            required: 'reviewDescription-required'
        },
    };

    $form.validationEngine(validationOptions);
    var arf = $form.data('validationEngine');

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);
        var data = envelope.message.data;

        var $articleReviewControl = $('.x-control.x-article-reviews[data-type="reviews"]:first');

        if ($articleReviewControl.length == 0)
            throw new Error('Article review control does not exist.');

        if (data) {
            $articleReviewControl.find('.critics.form-show-hide').remove();
            $articleReviewControl.find('.already-reviewed-status').show();
            $articleReviewControl.find('.critics.review-status').show();
        }
    };

    form.onFailure = function (envelope) {
        formloading(false);

        $('.js-error', $form).show();
    };

    form.submit = function () {
        form.loading(true);

        $('input[name]:not([type="checkbox"]):not([type="radio"]), textarea[name]', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.Article.Messages.ReviewSubmit(formData.reviewArticleId, formData.reviewTitle, formData.reviewDescription, formData.reviewRating));
    };

    $form.on('keyup', 'input[name], textarea[name]', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();
        arf.validate(fieldName);
    }); 

    $form.on('click', ".js-submit-button", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val = arf.validate();
        if (val) form.submit();
    });

    Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewFailure, form, form.onFailure);
});

